import { State } from "../types/state";

export const resetUserCurrentLocation = (state: State) => {
  state.currentLocation = {};
};
